import React from 'react';
import { useStaff } from '../../db/hooks/useLookupData';
import { User, UserPlus } from 'lucide-react';
import { Modal } from '../common/Modal';

interface POSOperatorPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectOperator: (operadorId: string) => void;
  onAddNewStaff?: () => void;
}

export function POSOperatorPickerModal({
  isOpen,
  onClose,
  onSelectOperator,
  onAddNewStaff,
}: POSOperatorPickerModalProps) {
  const { staff = [] } = useStaff();

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="¿Quién atiende esta sesión?"
      subtitle="Selecciona al profesional responsable para asignar comisiones y propinas"
      icon={User}
      maxWidth="md"
      zIndexClass="z-[80]"
    >
      <div className="space-y-4 py-2">
        {staff.length === 0 ? (
          <div className="p-6 text-center bg-surface-secondary rounded-2xl border border-dashed border-border flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 rounded-2xl bg-brand-orange/10 text-brand-orange flex items-center justify-center border border-brand-orange/20">
              <UserPlus className="w-5 h-5" />
            </div>
            <div>
              <p className="text-xs font-bold text-text-primary">
                No hay miembros de staff registrados
              </p>
              <p className="text-[11px] font-semibold text-text-tertiary mt-0.5">
                Registra a tu primer profesional para asignarle servicios y comisiones.
              </p>
            </div>
            {onAddNewStaff && (
              <button
                type="button"
                onClick={onAddNewStaff}
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-brand-orange text-white text-xs font-bold shadow-md shadow-brand-orange/20 hover:bg-brand-orange/90 transition-colors cursor-pointer"
              >
                <UserPlus className="w-4 h-4" />
                Registrar Personal Ahora
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-3">
              {staff.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => {
                    onSelectOperator(p.id);
                    onClose();
                  }}
                  className="p-4 rounded-2xl bg-surface border border-border hover:border-brand-sky hover:bg-brand-sky/15 flex flex-col items-center justify-center gap-2 transition-all group cursor-pointer shadow-xs hover:shadow-md"
                >
                  <div className="w-12 h-12 bg-brand-orange/10 rounded-2xl flex items-center justify-center text-brand-orange font-black text-lg group-hover:scale-110 transition-transform border border-brand-orange/20">
                    {p.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="text-center">
                    <span className="font-extrabold text-sm text-text-primary group-hover:text-brand-sky block">
                      {p.name}
                    </span>
                    <span className="text-[11px] font-semibold text-text-tertiary block capitalize">
                      {p.role || 'Esteticista'}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            {onAddNewStaff && (
              <div className="pt-2 border-t border-border flex justify-end">
                <button
                  type="button"
                  onClick={onAddNewStaff}
                  className="text-xs font-bold text-brand-sky hover:underline flex items-center gap-1.5 cursor-pointer py-1"
                >
                  <UserPlus className="w-3.5 h-3.5" />
                  + Registrar nuevo personal
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
}

